import React, { FC } from 'react'
import { InnerContainer } from './styles'
import { useTranslation } from '../../../hooks/locale'
import { RegionMapTransport } from '../../../transports/home-page-transport'
import { RegionCountMap } from './region-count'
import { Section, Title, TitleContainer } from '../common/styles'

interface RegionsMapCountProps {
    regionsMap: RegionMapTransport
}

const RegionCountSection: FC<RegionsMapCountProps> = ({ regionsMap }) => {
    const { t } = useTranslation()

    return (
        <Section id="region-count-section">
            <TitleContainer>
                <Title>{t('pages.home.regionCount.heading')}</Title>
            </TitleContainer>
            <InnerContainer>
                <RegionCountMap regionsMap={regionsMap} itemsPerCol={7} keyPrefix="region-count-map" />
            </InnerContainer>
        </Section>
    )
}

export default RegionCountSection
